import selectors from "@/lib/selectors";

export default function (node, variant) {
  const btn = node.querySelector(selectors.product.addButton);
  const text = btn.querySelector(selectors.product.addButtonText);

  const { langAvailable, langSoldOut, langUnavailable } = btn.dataset;

  if (!variant) {
    btn.setAttribute("disabled", "disabled");
    text.textContent = langUnavailable;
  } else if (variant.available) {
    btn.removeAttribute("disabled");
    text.textContent = langAvailable;
  } else {
    btn.setAttribute("disabled", "disabled");
    text.textContent = langSoldOut;
  }
}
